/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @typescript-eslint/no-explicit-any */

import { AuthContext } from "@app/context/AuthContext";
import STORAGE_KEYS from "@src/constants/storageKeys";
import useLocalStorage from "@src/hooks/useLocalStorage";
import {
  ReactNode,
  useMemo
} from "react";



type AuthProviderProps = { children: ReactNode }

export default function AuthProvider({ children }: AuthProviderProps) {
  const { set, get } = useLocalStorage();

  const setLoggedInUser = async (data: any) => {
    await set(STORAGE_KEYS.auth_details, data)
  }

  const getLoggedInUser = async () => {
    const result = await get(STORAGE_KEYS.auth_details)
    if (result) {
      return result
    }
    return null
  }

  const authContextValues = useMemo(
    () => ({
      setLoggedInUser,
      getLoggedInUser,
    }),
    [setLoggedInUser],
  )

  return (
    <AuthContext.Provider value={authContextValues}>
      {children}
    </AuthContext.Provider>
  )
}